module.exports = __webpack_public_path__ + "img/vcontroller-show-btn2-model.3c7bb372.jpg";